import { BlogIndexPage } from "@/components/blog/blog-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/government/blog/")({
  component: () => (
    <BlogIndexPage portal="government" basePath="/government/blog" />
  ),
});
